import { TextSelection } from 'prosemirror-state';
import { browser } from '../../libs';
import { DecoKey } from '../decoration';
var chainClickEvent = function (params) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return Array.from(args).some(function (handler) { return handler(params); });
};
var chainKeyDownEvent = function (view, event) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return Array.from(args).some(function (handler) { return handler({ view: view, event: event }); });
};
var checkIsRawBlock = function (node) { return node && node.isBlock && !node.isTextblock; };
// insert default node in the middle when text cannot be inserted to the before and after node
var insertDefaultNodeWhenBlock = function (view, pos, event) {
    var _a, _b, _c, _d;
    // get the previous dom, check if it is the right dom;
    var fixPos = 0;
    if (pos > 0) {
        var $dom = view.nodeDOM(pos - 1);
        if (!$dom) {
            var $pos_1 = view.state.doc.resolve(pos);
            if (!$pos_1.depth && $pos_1.nodeBefore) {
                $dom = view.nodeDOM(pos - $pos_1.nodeBefore.nodeSize);
            }
        }
        if (!$dom)
            return;
        var rect = (_b = (_a = $dom) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (!rect)
            return;
        if (Math.floor(rect.bottom) > event.clientY)
            fixPos = -1;
    }
    var $pos = view.state.doc.resolve(pos + fixPos);
    var defaultType = view.state.doc.type.contentMatch.defaultType;
    if (defaultType && $pos.node().type === view.state.doc.type) {
        var nodeBefore = $pos.nodeBefore, nodeAfter = $pos.nodeAfter;
        if ((!$pos.pos || checkIsRawBlock(nodeBefore)) && checkIsRawBlock(nodeAfter)) {
            var $dom = view.nodeDOM($pos.pos);
            if (!$dom)
                return;
            var rect = (_d = (_c = $dom) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect) === null || _d === void 0 ? void 0 : _d.call(_c);
            if (!rect || Math.ceil(rect.top) < event.clientY)
                return;
            var dispatch = view.dispatch, state = view.state;
            var tr = state.tr.insert($pos.pos, defaultType.create());
            tr = tr.setSelection(TextSelection.create(tr.doc, $pos.pos + 1));
            dispatch(tr);
            view.focus();
        }
    }
};
var zeroRegTail = /\u200B+$/;
var zeroRegHead = /^\u200B+/;
var doPassZeroTr = function (direction, view) {
    var decorationState = DecoKey.getState(view.state);
    var decorations = decorationState.find(undefined, undefined, function (spec) { return spec.shadowType === 'inline'; });
    var _a = view.state.selection, $from = _a.$from, empty = _a.empty;
    var passNode = direction > 0 ? $from.nodeAfter : $from.nodeBefore;
    if (!passNode || !passNode.isText)
        return false;
    var reg = direction > 0 ? zeroRegHead : zeroRegTail;
    var matchRes = passNode.textContent.match(reg);
    if (!matchRes)
        return false;
    var dispatch = view.dispatch, state = view.state;
    var newPos = direction > 0 ? $from.pos + matchRes[0].length : $from.pos - matchRes[0].length + (empty ? 0 : 1);
    var preventDefault = false;
    if (empty &&
        decorations.some(function (_a) {
            var from = _a.from;
            return (newPos < from && $from.pos > from) || (newPos > from && $from.pos < from);
        })) {
        preventDefault = true;
    }
    dispatch(state.tr.setSelection(TextSelection.create(state.doc, newPos)));
    return preventDefault;
};
var passZeroWidthChar = function (_a) {
    var view = _a.view, event = _a.event;
    var keyCode = event.keyCode, which = event.which, key = event.key;
    if (keyCode === 39 || which === 39 || key === 'ArrowRight') {
        return doPassZeroTr(1, view);
    }
    else if (keyCode === 37 || which === 37 || key === 'ArrowLeft') {
        return doPassZeroTr(-1, view);
    }
    return false;
};
var createPlaceHolder = function (placeholder) { return function (view) {
    var span = document.createElement('span');
    span.classList.add('syl-placeholder');
    var parent = view.state.selection.$from.parent;
    var styleText = 'cursor: text; text-indent: initial; pointer-events: none; -webkit-user-select: none; user-select: none;';
    if ((!browser.android && !browser.ios && !browser.mac) || (browser.mac && browser.chrome)) {
        styleText += ' position: absolute;';
    }
    if (parent.attrs.align === 'right') {
        var paddingRight = parseInt(window.getComputedStyle(view.dom).paddingRight, 10);
        styleText += " right: " + paddingRight + "px";
    }
    else if (parent.attrs.align === 'center') {
        styleText += ' transform: translateX(-50%);';
    }
    span.setAttribute('style', styleText);
    span.setAttribute('ignoreel', 'true');
    span.addEventListener('click', function () { return view.focus(); });
    span.innerHTML = placeholder;
    return span;
}; };
export { chainClickEvent, chainKeyDownEvent, createPlaceHolder, insertDefaultNodeWhenBlock, passZeroWidthChar, };
//# sourceMappingURL=utils.js.map